/**
 * The 38 multilingual SEO pages: every slug, its page type and, for the
 * language pages, the language. Plain data and no content, so App.js can
 * route all 38 without pulling their JSON into the main bundle (the content
 * loads with the lazy page chunk, catalog.js).
 *
 * CommonJS on purpose: scripts/routes.js (prerender) and
 * scripts/gates/multilingual-content.js read this from Node.
 *
 * A slug is the page's path without the leading "/". Its content file is
 * ./<slug>.json. Every slug is ROUTED (App.js) whether or not it is
 * published: an unpublished page must render the 404 page, and without a
 * route of its own a /learn/... slug would fall through to LearnPage, which
 * redirects to the homepage.
 */

const HUB = "features/multilingual-automation";
const MAIN_RANKING = "learn/best-multilingual-instagram-dm-automation-tools";

const LEARN = [
  "learn/instagram-auto-dm-kaise-kare",
  "learn/how-to-auto-reply-instagram-comments-in-different-languages",
  "learn/can-instagram-auto-dm-work-in-hindi",
  "learn/what-is-multilingual-comment-to-dm",
  "learn/can-one-automation-reply-in-multiple-languages",
  "learn/best-comment-keywords-in-hindi-and-hinglish",
  "learn/hindi-or-hinglish-dm-which-should-you-use",
  "learn/reach-regional-language-audience-on-instagram",
];

/**
 * key: the slug suffix. lang: the BCP 47 tag of the language, used on its
 * native-script text (nativeScript.js). Hindi and Marathi share Devanagari,
 * so on a Marathi page a Devanagari run is "mr"; everywhere else it is "hi".
 */
const LANGUAGES = [
  { key: "hindi", lang: "hi" },
  { key: "hinglish", lang: "hi-Latn" },
  { key: "marathi", lang: "mr" },
  { key: "gujarati", lang: "gu" },
  { key: "tamil", lang: "ta" },
  { key: "telugu", lang: "te" },
  { key: "kannada", lang: "kn" },
  { key: "malayalam", lang: "ml" },
  { key: "spanish", lang: "es" },
  { key: "french", lang: "fr" },
  { key: "german", lang: "de" },
  { key: "turkish", lang: "tr" },
  { key: "japanese", lang: "ja" },
  { key: "korean", lang: "ko" },
];

const languagePageSlug = (key) => `${HUB}/${key}`;
const rankingPageSlug = (key) => `learn/best-instagram-auto-dm-tools-for-${key}`;

/** slug -> { type, language? } — the type each file MUST declare. */
const PAGE_TYPES = {};
PAGE_TYPES[HUB] = { type: "hub" };
PAGE_TYPES[MAIN_RANKING] = { type: "ranking_main" };
for (const s of LEARN) PAGE_TYPES[s] = { type: "learn" };
for (const l of LANGUAGES) {
  PAGE_TYPES[languagePageSlug(l.key)] = { type: "language", language: l };
  PAGE_TYPES[rankingPageSlug(l.key)] = { type: "ranking_language", language: l };
}

/** Every slug, in the order the hub lists them. */
const SLUGS = Object.keys(PAGE_TYPES);

module.exports = {
  HUB,
  MAIN_RANKING,
  LEARN,
  LANGUAGES,
  PAGE_TYPES,
  SLUGS,
  languagePageSlug,
  rankingPageSlug,
};
